import React from "react"

function Cake({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.9999 13.8647V12.3364"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9994 7.51074C17.9994 7.51074 16.709 9.98462 16.709 11.0444C16.709 11.7565 17.2873 12.3348 17.9994 12.3348C18.7115 12.3348 19.2898 11.7565 19.2898 11.0444C19.2898 9.98462 17.9994 7.51074 17.9994 7.51074Z"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4776 17.8677V13.8638H16.5223V17.8677"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3665 17.8682H24.5701C27.161 18.0212 26.5732 22.3294 23.2229 20.364C22.792 21.6471 21.1574 21.7421 20.6281 20.364C19.9846 21.5694 18.4237 21.7551 17.9067 20.364C17.2559 21.5902 15.6067 21.7635 15.2281 20.364C14.6279 21.6538 13.054 21.7601 12.6277 20.364C9.48048 22.6972 8.85555 17.8575 11.3665 17.8682Z"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3664 25.3384H24.57"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3664 22.1875V28.4881H24.57V22.2212"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Cake
